import React from 'react'
import {
    TableCell,
} from '@material-ui/core'
import dayjs from 'dayjs'

import BaseTable from '../BaseTable'

function LogTable({
    data,
    onViewHandler,
}) {
    const logRow = (log) => {
        return (
            <>
                <TableCell align="center">{log.subject}</TableCell>
                <TableCell align="center">{log.sendType}</TableCell>
                <TableCell align="center">{log.reciever}</TableCell>
                <TableCell align="center">{log.createdAt ? dayjs(log.createdAt).format('YYYY-MM-DD HH:mm'): '-'}</TableCell>
            </>
        )
    }

    return (
        <BaseTable
            withIndex
            headers={['subject', 'type', 'reciever', 'sent at']}
            data={data}
            getRow={logRow}
            hasAction
            onViewHandler={onViewHandler}
        />
    )
}

export default LogTable